import React from 'react';
import Navbar from './Navbar';
import NotificationPrompt from './NotificationPrompt';
import AvaniAiBanner from './AvaniAiBanner';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      <Navbar />
      <main className="container mx-auto p-4 sm:p-6 lg:p-8 pt-20 sm:pt-24 lg:pt-28">
        <AvaniAiBanner />
        {children}
      </main>
      {/* Bottom-left bell + first-visit "Enable notifications" banner.
          Sits at the layout level so every authenticated page picks it up. */}
      <NotificationPrompt />
    </div>
  );
};

export default Layout;